import { Reducer } from 'redux';
import { CommentActionTypes } from './actions';

// Type-safe initialState!
const initialState = {
  reportComments: [],
  reports: [],
};

type ICommentStoreState = Readonly<typeof initialState>;

const reducer: Reducer<ICommentStoreState> = (state = initialState, action) => {
  switch (action.type) {
    case CommentActionTypes.GET_COMMENTS: {
      //console.log('search result:', action.value);
      let _state = { ...state };
      _state = {
        ..._state,
        reportComments: [
          ..._state.reportComments,
          ...action.value.filter(
            (x) => !_state.reportComments.some((y) => y.id == x.id)
          ),
        ],
      };
      return _state;
    }
    case CommentActionTypes.GET_REPORT_FOR_COMMENTS: {
      //console.log('search result:', action.value);
      let _state = { ...state };
      _state = {
        ..._state,
        reports: [
          ..._state.reports,
          action.value, 
          // We're always bringing back singled or default, so this will never be an array,
           /*.filter(
            (x) => !_state.reportComments.some((y) => y.id == x.id)
          ),*/
        ],
      };
      return _state;
    }
    case CommentActionTypes.SAVE_NEW_REPORT_COMMENT: {
      //console.log('search result:', action.value);
      let _state = { ...state };
      _state = {
        ..._state,
        reportComments: [..._state.reportComments, action.value],
      };
      return _state;
    }
    case CommentActionTypes.SAVE_COMMENT_VIEW: {
      //console.log('search result:', action.value);
      let _state = { ...state };
      _state = {
        ..._state,
        reportComments: _state.reportComments.map((rc) => {
          return rc.id == action.value.commentId
            ? { ...rc, commentViews: [...rc.commentViews, action.value] }
            : rc;
        }),
      };
      console.log(_state);
      return _state;
    }
    default: {
      return state;
    }
  }
};

export default reducer;
